/* jshint esversion: 6 */

let ConstantMixin = {
	getPostServiceNameByCode: function (code) {
		let constants = window.DlvrConstants;
		code = parseInt(code, 10);

		switch (code) {
			case constants.POST_SVC_TWITTER:
				return "X (Twitter)";

			case constants.POST_SVC_FACEBOOK:
				return "Facebook";

			case constants.POST_SVC_TUMBLR:
				return "Tumblr";

			case constants.POST_SVC_BLOGGER:
				return "Blogger";

			case constants.POST_SVC_REDDIT:
				return "Reddit";

			case constants.POST_SVC_WORDPRESS:
				return "Wordpress";

			case constants.POST_SVC_LINKEDIN:
				return "LinkedIn";

			case constants.POST_SVC_STATUSNET:
				return "StatusNet";

			case constants.POST_SVC_FEED:
				return "Feed";

			case constants.POST_SVC_STOCKTWITS:
				return "StockTwits";

			case constants.POST_SVC_PINTEREST:
				return "Pinterest";

			case constants.POST_SVC_SLACK:
				return "Slack";

			case constants.POST_SVC_DISCORD:
				return "Discord";

			case constants.POST_SVC_GMYBUSINESS:
				return "Google Business Profile";

			case constants.POST_SVC_INSTAGRAM_BUSINESS:
				return "Instagram Professional";

			case constants.POST_SVC_MASTODON:
				return "Mastodon";

			case constants.POST_SVC_TIKTOK:
				return "TikTok";

			case constants.POST_SVC_BLUESKY:
				return "Bluesky";

			case constants.POST_SVC_NEXTDOOR:
				return "Nextdoor";

			case constants.POST_SVC_YOUTUBE:
				return "YouTube";

			case constants.POST_SVC_THREADS:
				return "Threads";

			case constants.POST_SVC_SNAPCHAT:
				return "Snapchat";

			default:
				return "";
		}
	},
	getInputServiceByCode: function (code) {
		let constants = window.DlvrConstants;
		code = parseInt(code, 10);

		switch (code) {
			case constants.INPUT_TYPE_FEED:
				return "Feed";

			case constants.INPUT_TYPE_TWITTER:
				return "X (Twitter)";

			case constants.INPUT_TYPE_INSTAGRAM:
				return "Instagram";

			case constants.INPUT_TYPE_FACEBOOK_PAGE:
				return "Facebook";

			case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
				return "Instagram Professional";

			case constants.INPUT_SUBTYPE_PINTEREST:
				return "Pinterest";

			case constants.INPUT_SUBTYPE_WORDPRESS:
				return "Wordpress";

			case constants.INPUT_SUBTYPE_YOUTUBE:
				return "YouTube";

			case constants.INPUT_SUBTYPE_VIMEO:
				return "Vimeo";

			case constants.INPUT_SUBTYPE_EBAY:
				return "ebay";

			case constants.INPUT_SUBTYPE_ETSY:
				return "Etsy";

			case constants.INPUT_SUBTYPE_SHOPIFY:
				return "Shopify";

			case constants.INPUT_SUBTYPE_SUBSTACK:
				return "Substack";

			case constants.INPUT_TYPE_TIKTOK:
				return "TikTok";

			case constants.INPUT_TYPE_YOUTUBE:
				return "YouTube";

			default:
				return "";
		}
	},
	getShortenServiceByCode: function (code) {
		let constants = window.DlvrConstants;
		code = parseInt(code, 10);

		switch (code) {
			case constants.SHORTEN_SVC_NONE:
				return "None";

			case constants.SHORTEN_SVC_DLVRIT:
				return "dlvr.it";

			case constants.SHORTEN_SVC_BITLY:
				return "bit.ly";

			case constants.SHORTEN_SVC_CUSTOM:
				return "Custom";

			default:
				return "";
		}

	},
	getGenericSerivceByCode: function (code) {
		let constants = window.DlvrConstants;
		code = parseInt(code, 10);

		switch (code) {
			case constants.GENERIC_SVC_WORDPRESS:
				return "Wordpress";

			default:
				return "";
		}

	},
	getIconIndexByCode: function (code, type) {
		let index = '',
				constants = window.DlvrConstants;

		code = parseInt(code, 10);

		// shorteners and post_svc codes collide so look them up separately
		if (type == 'generic') {
			switch (code) {
				case constants.GENERIC_SVC_WORDPRESS:
					index = "wordpress";
					break;
			}
		} else if (type === 'login') {
			switch (code) {
				case constants.LOGIN_SVC_TWITTER:
					index = 'x';
					break;

				case constants.LOGIN_SVC_FACEBOOK:
					index = 'facebook';
					break;

				case constants.LOGIN_SVC_GOOGLE:
					index = 'google';
					break;
			}
		} else if (type == 'shortener') {
			switch (code) {
				case constants.SHORTEN_SVC_NONE:
					index = "none";
					break;

				case constants.SHORTEN_SVC_DLVRIT:
					index = "dlvr";
					break;

				case constants.SHORTEN_SVC_BITLY:
					index = "bitly";
					break;

				case constants.SHORTEN_SVC_CUSTOM:
					index = "customShortener";
					break;

				case constants.PUB_DOMAIN:
					index = "customDomain";
					break;

			}
		} else {
			switch (code) {
				case constants.BULK_SVC_TWITTER:
				case constants.INPUT_TYPE_TWITTER:
				case constants.POST_SVC_TWITTER:
					index = "x";
					break;

				case constants.INPUT_TYPE_FACEBOOK_PAGE:
				case constants.POST_SVC_FACEBOOK:
					index = "facebook";
					break;

				case constants.POST_SVC_TUMBLR:
					index = "tumblr";
					break;

				case constants.POST_SVC_BLOGGER:
					index = "blogger";
					break;

				case constants.POST_SVC_REDDIT:
					index = "reddit";
					break;

				case constants.POST_SVC_WORDPRESS:
					index = "wordpressOutput";
					break;

				case constants.POST_SVC_LINKEDIN:
					index = "linkedin";
					break;

				case constants.POST_SVC_STATUSNET:
					index = "statusnet";
					break;

				case constants.BULK_SVC_FEED:
				case constants.INPUT_TYPE_FEED:
				case constants.POST_SVC_FEED:
					index = "feed";
					break;

				case constants.POST_SVC_STOCKTWITS:
					index = "stocktwits";
					break;

				case constants.BULK_SVC_INSTAGRAM:
				case constants.INPUT_TYPE_INSTAGRAM:
					index = "instagram";
					break;

				case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
				case constants.POST_SVC_INSTAGRAM_BUSINESS:
					index = "instagrambusiness";
					break;

				case constants.POST_SVC_PINTEREST:
				case constants.INPUT_SUBTYPE_PINTEREST:
					index = "pinterest";
					break;

				case constants.POST_SVC_SLACK:
					index = "slack";
					break;

				case constants.POST_SVC_DISCORD:
					index = "discord";
					break;

				case constants.POST_SVC_GMYBUSINESS:
					index = "gmb";
					break;

				case constants.POST_SVC_MASTODON:
					index = "mastodon";
					break;

				case constants.POST_SVC_BLUESKY:
					index = "bluesky";
					break;

		        case constants.POST_SVC_NEXTDOOR:
		          	index = "nextdoor";
		          	break;

				case constants.INPUT_TYPE_TIKTOK:
				case constants.POST_SVC_TIKTOK:
					index = "tiktok";
					break;

				case constants.POST_SVC_THREADS:
					index = "threads";
					break;

				case constants.POST_SVC_SNAPCHAT:
					index = "snapchat";
					break;

		        case constants.INPUT_SUBTYPE_WORDPRESS:
					index = "wordpress";
					break;

				case constants.INPUT_TYPE_YOUTUBE:
				case constants.INPUT_SUBTYPE_YOUTUBE:
				case constants.POST_SVC_YOUTUBE:
					index = "youtube";
					break;

				case constants.INPUT_SUBTYPE_VIMEO:
					index = "vimeo";
					break;

				case constants.INPUT_SUBTYPE_EBAY:
					index = "ebay";
					break;

				case constants.INPUT_SUBTYPE_ETSY:
					index = "etsy";
					break;

				case constants.INPUT_SUBTYPE_SHOPIFY:
					index = "shopify";
					break;

				case constants.INPUT_SUBTYPE_SUBSTACK:
					index = "substack";
					break;

        		default:
					break;
			}
		}

		if (index === '') {
			index = 'generic';
		}

		return index;

	},
	getSubtypeLabel(type, subtype) {
		let subTypeLabel = '',
				constants = window.DlvrConstants;

		if (type === constants.POST_SVC_LINKEDIN) {
			switch (subtype) {
				case constants.LI_PERSON:
					subTypeLabel = "Person";
					break;

				case constants.LI_COMPANY:
					subTypeLabel = 'Company'
					break;

				default:
					break;
			}

		} else if (type === constants.POST_SVC_FACEBOOK) {
			switch (subtype) {
				case constants.FB_PROFILE:
					subTypeLabel = "Profile";
					break;

				case constants.FB_GROUP:
					subTypeLabel = "Group";
					break;

				case constants.FB_PAGE:
					subTypeLabel = "Page";
					break;

				default:
					break;
			}

		}

		return subTypeLabel;
	}

};

export default ConstantMixin;
